import { useCallback, useState, useEffect } from 'react';

import { useIsEditorToolbarDockedAtTop } from '@confluence/content-types-header/entry-points/useIsEditorToolbarDockedAtTop.tsx';
import type { BannerType } from '@confluence/editor-controls-banner-dismissal';
import {
	getBannerType,
	persistBannerDismissalNewPinning,
	isBannerDismissedInLocalStorage,
} from '@confluence/editor-controls-banner-dismissal';

export const useIsControlsBannerDismissed = (
	isLivePage: boolean,
): {
	isControlsBannerDismissed: boolean;
	onDismiss: () => void;
	bannerType: BannerType;
} => {
	const isEditorToolbarDockedAtTop = useIsEditorToolbarDockedAtTop({
		defaultDockedAtTop: !isLivePage,
	});

	const bannerType = getBannerType(isEditorToolbarDockedAtTop);

	const [isControlsBannerDismissed, setIsControlsBannerDismissed] = useState(() =>
		isBannerDismissedInLocalStorage(bannerType),
	);

	useEffect(() => {
		setIsControlsBannerDismissed(isBannerDismissedInLocalStorage(bannerType));
	}, [bannerType]);

	const onDismiss = useCallback((): void => {
		setIsControlsBannerDismissed(true);
		persistBannerDismissalNewPinning(bannerType);
	}, [bannerType]);

	return { isControlsBannerDismissed, onDismiss, bannerType };
};
